const api = "https://whitelabel.buildzone.net/live/graphql/";
const diamondListingApi = "diamondData";
const diamondDetailApi = "diamondById";
const diamondpairListingApi = "pairDiamondData";
const diamondpairDetailApi = "pairDiamondById";
const diamondSearchByReportApi = "diamondByStockorcert";
const diamondAddToCart = "diamondAddToCart";
const pendantAddToCart = "pendentAddToCart";
const ringAddToCart = "ringAddToCart";
const productMetafield = "productMetafield";
const earringAddToCart = "earringAddToCart";
var currencyCode = "{{ cart.currency.iso_code }}";
var currencySymbol = getCurrenySymbol(currencyCode);

/*** get currency symbol start ***/
function getCurrenySymbol(CurrenyCode) {
	var currency_symbol;
	switch (CurrenyCode) {
		// for now we have only single currency*- USD

		case 'USD':
			currency_symbol = '$';
			break;
        case 'GBP':
			currency_symbol = '£';
			break;

		default:
			currency_symbol = '£';
	}

	return currency_symbol;
}
/*** get currency symbol end ***/

/*** addCommas in price start ***/
function addCommas(price) {
  price += '';
  x = price.split('.');
  x1 = x[0];
  x2 = x.length > 1 ? '.' + x[1] : '';
  var rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1' + ',' + '$2');
  }
  return x1 + x2;
}
/*** addCommas in price end ***/

/*** set selected filters for session filters after reloading page start ***/
function setSelectedFilter(filter_value, func, hasSelectedClass, input_value = '') {      
	if (input_value == 'price') {
		$('.selected_filter_container').find('li[data-input="price"]').remove();
	}else if (input_value == 'carat') {
		$('.selected_filter_container').find('li[data-input="carat"]').remove();
	}else if (input_value == 'depth') {
		$('.selected_filter_container').find('li[data-input="depth"]').remove();
	}else if (input_value == 'table') {
		$('.selected_filter_container').find('li[data-input="table"]').remove();
	}

	var value = filter_value.split(':');
	if (hasSelectedClass) {
		var html = '';
        var filter_lable = value[1].trim();
         if(input_value == 'price' && input_value != 'carat' && input_value != 'depth' && input_value != 'table' && input_value != 'cut' && input_value != 'polish' && input_value != 'symmetry' && input_value != 'fluorescence' && input_value != 'clarity' && input_value != 'color' && input_value != 'intensity') {
           //filter_lable = filter_lable.replace(/\-/g, ' ');
         }
		html += '<li onclick="' + func + '" data-input="' + input_value + '" data-filter_value="' + filter_value + '"><div class="tps_filter_values">' + filter_lable + '<span class="tps-pendantbuilder-remove-option"></span></div></li>';
		if ($('#' + value[0] + '_container').length > 0) {
			$('#' + value[0] + '_container').append(html);
		} else {
			var elecontainer = '<ul id="' + value[0] + '_container"><span class="tps_applied_filter_lable">' + value[0] + ':</span></ul>';
			$('.selected_filter_container').append(elecontainer);
			$('#' + value[0] + '_container').append(html);
		}      
	} else {
		$('.selected_filter_container').find('li[data-filter_value="' + filter_value + '"]').remove();
		if ($('input[value="' + input_value + '"]').length > 0) {
			$('input[value="' + input_value + '"]').prop('checked', false);
		}

		if ($('#' + value[0] + '_container li').length == 0) {
			$('#' + value[0] + '_container').remove();
		}
	}
	if ($('.selected_filter_container li').length > 0) {
		$('.tps_selected_filter_wrapper').show();
	} else {
		$('.tps_selected_filter_wrapper').hide();
	}
}
/*** set selected filters for session filters after reloading page end ***/

/*** tps config function to get urls start ***/
var tps_config = {
	"urls": {
        "earring_builder_listing": "/collections/build-your-own-earring",
        "earringbuilder_loose_diamond": "/pages/earring-builder-diamond-listing",
        "earringbuilder_lab_diamond": "/pages/earring-builder-lab-diamond-listing",
        "earringbuilder_loose_diamond_detail": "/pages/earring-builder-diamond-details",
        "earring_builder_final_page": "/pages/final-earring",
		"pendant_builder_listing": "/collections/build-your-own-pendant",		
		"pendantbuilder_loose_diamond": "/pages/pendant-builder-diamond-listing",
        "pendantbuilder_lab_diamond": "/pages/pendant-builder-lab-diamond-listing",      
		"pendantbuilder_loose_diamond_detail": "/pages/pendant-builder-diamond-details",        
        "pendant_builder_final_page": "/pages/final-pendant",
        "ring_builder_listing": "/collections/build-your-own-ring",		
		"ringbuilder_loose_diamond": "/pages/ring-builder-diamond-listing",
        "ringbuilder_lab_diamond": "/pages/ring-builder-lab-diamond-listing",
		"ringbuilder_loose_diamond_detail": "/pages/ring-builder-diamond-details",
        "ring_builder_final_page": "/pages/final-ring",
        "loose_diamond": "/pages/loose-diamond",
        "lab_diamond": "/pages/lab-diamond",
        "loose_diamond_detail": "/pages/diamond-details",
	}

}
/*** tps config function to get urls end ***/

/*** Diamond Carat Filter Start ***/
var minDiamondCarat = parseFloat($('#diamondMincarat').val());
//alert(minDiamondCarat);
var maxDiamondCarat = parseFloat($('#diamondMaxcarat').val());
var carat = [];
/* Carat Calibreation Start*/ 
for (i = minDiamondCarat; i < 1; i = i + 0.01) {
	var dec = i.toFixed(2);
	carat.push(dec);
}
for (i = 1; i < 2; i = i + 0.05) {
	var dec = i.toFixed(2);
	carat.push(dec);
}
for (i = 2; i < 3; i = i + 0.10) {
	var dec = i.toFixed(2);
	carat.push(dec);
}
for (i = 3; i < maxDiamondCarat; i = i + 0.15) {
	var dec = i.toFixed(2);
	carat.push(dec);
}

/* Carat Calibreation End*/ 
carat.push(maxDiamondCarat);
Shopify.money_format = '&pound;{{amount}}';
var currency_symbol = "£";


function getClosestNum(num, ar) {
	var i = 0,
		closest, closestDiff, currentDiff;
	if (ar.length) {
		closest = ar[0];
		for (i; i < ar.length; i++) {
			closestDiff = Math.abs(num - closest);
			currentDiff = Math.abs(num - ar[i]);
			if (currentDiff < closestDiff) {
				closest = ar[i];
			}
			closestDiff = null;
			currentDiff = null;
		}
		//returns first element that is closest to number
		return closest;
	}
	//no length
	return false;
}

function get_index(value, array) {
	var pos = 0
	for (i = 0; i < array.length; i++) {
		if (array[i] == value) {
			pos = i;
			break;
		}
	}
	return pos;
}

function carat_slider_render(start, end, option) { 
    var start2 = getClosestNum(start, carat);
	var end2 = getClosestNum(end, carat);   
	var start1 = get_index(start2, carat);
	var start11 = get_index(start, carat);
	var end11 = get_index(end, carat);
	var end1 = get_index(end2, carat);
  
	var settingSelected = jQuery("#setting").val();

    var pendant_setting = localStorage.getItem("pendant_setting");
    var ring_setting = localStorage.getItem("ring_setting");

    var min_carat = parseFloat($("#diamondMincarat").val()).toFixed(2);
    var max_carat = parseFloat($("#diamondMaxcarat").val()).toFixed(2);

    if (window.location.href.indexOf('ring-builder-diamond-listing') > 0) {
       if(localStorage.getItem("ring_setting") != null){
          var ringsetting_details = jQuery.parseJSON(ring_setting);
          var min_carat = ringsetting_details[0].minimum_carat_total_weight;
          var max_carat = ringsetting_details[0].maximum_carat_total_weight;
          var isSelected = true;
       }
    }else if (window.location.href.indexOf('pendant-builder-diamond-listing') > 0) {
        if(localStorage.getItem("pendant_setting") != null){
          var setting_details = jQuery.parseJSON(pendant_setting);
          var min_carat = setting_details[0].minimum_carat_total_weight;
          var max_carat = setting_details[0].maximum_carat_total_weight;  
        }        
    }
  
     //session carat filter selected
     var isSelected = false;
     if(parseFloat(start).toFixed(2) != min_carat || parseFloat(end).toFixed(2) != max_carat){
       isSelected = true;
     }  
       
     var caratTitle = 'Carat: '+start + ' ct.'+' - '+end + ' ct.';
     setSelectedFilter(caratTitle,"carat_slider_render('"+min_carat+"', '"+max_carat+"','true')",isSelected,'carat');
     //end
  
	jQuery("#carat-slider").slider({      
		range: true,
		min: 0,
		max: carat.length - 1,
		values: [start1, end1],
		slide: function(event, ui) {  
            emptyResultDiv();
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}
			//disable min max slider if setting selected
			if (settingSelected == 1 && (parseFloat(start) > parseFloat(carat[parseInt(ui.values[0])]) || parseFloat(end) < parseFloat(carat[parseInt(ui.values[1])]))) {
				return false;
			}
          
			$("#carat_from").val(carat[parseInt(ui.values[0])] + ' ct.');
			$('#carat_left_hidden').val(carat[parseInt(ui.values[0])]);
			$('#carat_to').val(carat[parseInt(ui.values[1])] + ' ct.');
			$('#carat_right_hidden').val(carat[parseInt(ui.values[1])]);
		},
		change: function(event, ui) {
            emptyResultDiv();
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}			

			if (option) {  
				jQuery('#page_no').val(1);
				jQuery('#pagination').val('');               

                //applied filter code start here                              
                 var isSelected = false;                        
                 if(carat[parseInt(ui.values[0])] != min_carat || carat[parseInt(ui.values[1])] != max_carat){
                       isSelected = true;
                 }else if(localStorage.getItem("ring_setting") != null){                   
                   if(carat[parseInt(ui.values[0])] == min_carat || carat[parseInt(ui.values[1])] == max_carat){                    
                     isSelected = true;
                   }                   
                 }

                setTimeout(function(){  
                    var caratLeft = $('#carat_left_hidden').val();
                    var caratRight = $('#carat_right_hidden').val();
                    var caratTitle = 'Carat: '+caratLeft+ ' ct.'+' - '+caratRight+ ' ct.';
                    //var caratTitle = 'Carat: '+start+ ' ct.'+' - '+end+ ' ct.';
                    setSelectedFilter(caratTitle,"carat_slider_render('"+min_carat+"', '"+max_carat+"','true')",isSelected,'carat');
                    //end 
    
                    var reportFlag = jQuery('#tps_search_by_report_no').val();                
                    if(reportFlag == ''){
                      graphqlDataCall();
                    }
                }, 20);
    			               
			}
           
		}

	});

    
    start = start ? start : minDiamondCarat;
    $("#carat_from").val(start + ' ct.');
    $("#carat_to").val(end + ' ct.');
    $('#carat_left_hidden').val(start);
    $('#carat_right_hidden').val(end);
    
}


function replace_carat_from() {

	var min_carat_value = minDiamondCarat;
 
	var settingSelected = jQuery("#setting").val();
  

	if (jQuery('#carat_from').val() == '') {
		var value = parseFloat(jQuery('#carat_left_hidden').val()).toFixed(2);
		jQuery('#carat_from').val(parseFloat(value).toFixed(2) + ' ct.');
		return false;
	} else {
		var hidden_carat_value = parseFloat($('#carat_left_hidden').val()).toFixed(2);
		var carat_value = parseFloat(jQuery('#carat_from').val()).toFixed(2);
	}
	
	var value = carat_value;
	var carat_value1_comma = value;
	value = carat_value1_comma;

	var value1 = parseFloat($('#carat_to').val());
	if (isNaN(value) != false) {
		var value = parseFloat(minDiamondCarat).toFixed(2);
		alert("Please enter value in number");
		jQuery('#carat_from').val(value + ' ct.');
	} else if (value > value1) {
		alert('Incorrect carat range!');
		$('#carat_from').val(parseFloat(hidden_carat_value).toFixed(2) + ' ct.');
		return false;
	} else if (carat_value < min_carat_value) {
		alert('Incorrect carat range!');
		$('#carat_from').val((parseFloat(min_carat_value).toFixed(2)) + " ct.");
		carat_slider_render(min_carat_value, value1, true);
		return false;
	} else if (settingSelected == 1 && (hidden_carat_value > carat_value)) {
		alert('selected setting can match with diamond greater than ' + carat_value);
		jQuery('#carat_from').val(hidden_carat_value + " ct.");
		return false;
	}
	$('#carat_left_hidden').val(value);
	$('#carat_right_hidden').val(value1);

	carat_slider_render(value, value1, true);

}

function replace_carat_to() {
	var max_carat_value = parseFloat(maxDiamondCarat).toFixed(2);
	var settingSelected = jQuery("#setting").val();
	if (jQuery('#carat_to').val() == '') {
		var value = parseFloat(jQuery('#carat_right_hidden').val()).toFixed(2);
		jQuery('#carat_to').val(parseFloat(value).toFixed(2) + ' ct.');
		return false;
	} else {
		var hidden_carat_value = parseFloat(jQuery('#carat_right_hidden').val()).toFixed(2);
		var carat_value = parseFloat(jQuery('#carat_to').val()).toFixed(2);
	}

	value = carat_value;
	var carat_value1_comma = value;
	value = carat_value1_comma;

	var value1 = parseFloat($('#carat_from').val());
    
	if (isNaN(value) != false) {
		var value = parseFloat(maxDiamondCarat).toFixed(2);
		alert("Please enter value in number");
		jQuery('#carat_to').val(value + ' ct.');
	} else if (parseFloat(value) > parseFloat(max_carat_value)) {
		alert('Incorrect carat range!');
		jQuery('#carat_to').val(hidden_carat_value + " ct.");
		return false;
	} else if (value1 > value) {
		alert('Incorrect carat range!');
		$('#carat_to').val(hidden_carat_value + ' ct.');
		return false;
	}else if (settingSelected == 1 && (hidden_carat_value < carat_value)) {
		alert('Selected setting can match with diamond less than ' + carat_value);
		jQuery('#carat_to').val(hidden_carat_value + " ct.");
		return false;
	}
   
	$('#carat_right_hidden').val(value);
	$('#carat_left_hidden').val(value1);

	carat_slider_render(value1, value, true);
}
/*** Diamond Carat Filter End ***/

/*** Diamond Price Filter End ***/
var price = [];
var minDiamondPrice = $('#diamondMinprice').val();
var maxDiamondPrice = $('#diamondMaxprice').val();

// for (var i = parseFloat(minDiamondPrice); i < 7000; i = i + 25) {
// 	price.push(i);
// };

// for (var i = 7000; i < parseFloat(maxDiamondPrice); i = i + 500) {
// 	price.push(i);
// };

for (var i = parseInt(minDiamondPrice); i < 2500; i = i+1) {
  price.push(i);
};
for (var i = 2500; i < 5000; i = i+10) {
  price.push(i);
};
for (var i = 5000; i < 6000; i = i+15) {
  price.push(i);
};
for (var i = 6000; i < 7000; i = i+20) {
  price.push(i);
};
for (var i = 7000; i < 8000; i = i+25) {
  price.push(i);
};
for (var i = 8000; i < 9000; i = i+30) {
  price.push(i);
};
for (var i = 9000; i < 10000; i = i+35) {
  price.push(i);
};
for (var i = 10000; i < 15000; i = i+40) {
  price.push(i);
};
for (var i = 15000; i < 25000; i = i+50) {
  price.push(i);
};
for (var i = 25000; i < 50000; i = i+100) {
  price.push(i);
};
for (var i = 50000; i < 80000; i = i+200) {
  price.push(i);
};
for (var i = 80000; i < 100000; i = i+500) {
  price.push(i);
};
for (var i = 100000; i < 200000; i = i+1000) {
  price.push(i);
};


price.push(parseInt(maxDiamondPrice));

// function addCommas(price) {
// 	price += '';
// 	x = price.split('.');
// 	x1 = x[0];
// 	x2 = x.length > 1 ? '.' + x[1] : '';
// 	var rgx = /(\d+)(\d{3})/;
// 	while (rgx.test(x1)) {
// 		x1 = x1.replace(rgx, '$1' + ',' + '$2');
// 	}
// 	return x1 + x2;
// }
function addCommas(price) {
	price += '';
	x = price.split('.');
	x1 = x[0];
	x2 = x.length > 1 ? '.' + x[1] : '';
	var rgx = /(\d+)(\d{3})/;
	while (rgx.test(x1)) {
		x1 = x1.replace(rgx, '$1' + ',' + '$2');
	}
	return x1 + x2;
}

var diamondMinprice = $('#diamondMinprice').val();
var diamondMaxprice = $('#diamondMaxprice').val();

function price_slider_render(start, end, option) {

    var start2=getClosestNum(start,price);
    var end2=getClosestNum(end,price);  
    var start1=get_priceindex(start2); 
    var start11=get_priceindex(start);
    var end11=get_priceindex(end);
    var end1=get_priceindex(end2); 

     //session price filter selected
     var isSelected = false;
     if(start != diamondMinprice || end != diamondMaxprice){
       isSelected = true;
     }

    var priceTitle = 'Price: '+Shopify.formatMoney(start*100, theme.moneyFormat)+' - '+Shopify.formatMoney(end*100, theme.moneyFormat);
     //var priceTitle = 'Price: '+currencySymbol+addCommas(start)+' - '+currencySymbol+addCommas(end);
 
    setSelectedFilter(priceTitle,"price_slider_render('"+diamondMinprice+"', '"+diamondMaxprice+"','true')",isSelected,'price');
    //end
  
   jQuery('#price-slider').slider({
       range: true,
       // values: [start, end],
       // min: Number(diamondMinprice),
       // max: Number(diamondMaxprice),
       //step: 1,
         min: 0,
         max: price.length-1,
         values: [ start1,end1 ],
         step:0.1,
       slide: function (event, ui) {
       // emptyResultDiv();
         
         if ((ui.values[0]) > (ui.values[1])) { 
            return false; 
        }
          jQuery('#price_left_hidden').val(price[parseInt(ui.values[0])]);
          jQuery('#price_right_hidden').val(price[parseInt(ui.values[1])]);
         
          var price_form = ""+Shopify.formatMoney(price[parseInt(ui.values[0])].toFixed(0)*100, theme.moneyFormat);
          jQuery('#price_from').val(price_form);
          var price_to = ""+Shopify.formatMoney(price[parseInt(ui.values[1])].toFixed(0)*100, theme.moneyFormat);
          jQuery('#price_to').val(price_to);
         
          option = true;
       }, change: function (event, ui) {
         if(option == true) {
           emptyResultDiv();
           
           jQuery('#price_left_hidden').val(price[parseInt(ui.values[0])]);
           jQuery('#price_right_hidden').val(price[parseInt(ui.values[1])]);
           var price_form = ""+Shopify.formatMoney(price[parseInt(ui.values[0])].toFixed(0)*100, theme.moneyFormat);
           jQuery('#price_from').val(price_form);

           var price_to = ""+Shopify.formatMoney(price[parseInt(ui.values[1])].toFixed(0)*100, theme.moneyFormat);
           jQuery('#price_to').val(price_to);      
  
           //applied filters 
           var isSelected = false;
           if(price[parseInt(ui.values[0])] != diamondMinprice || price[parseInt(ui.values[1])] != diamondMaxprice){
              isSelected = true;
           } 
           
           var priceTitle = 'Price: '+price_form+' - '+price_to;
           setSelectedFilter(priceTitle,"price_slider_render('"+diamondMinprice+"', '"+diamondMaxprice+"','true')",isSelected,'price');
          //end

           jQuery('#page_no').val(1);
    	   jQuery('#pagination').val('');
           
           var reportFlag = jQuery('#tps_search_by_report_no').val();                
           if(reportFlag == ''){
             graphqlDataCall();
           }
           return false;
         }else if(option == false){       
           
             jQuery('#price_left_hidden').val(start);
             jQuery('#price_right_hidden').val(end);

             var price_form = ""+Shopify.formatMoney(start*100, theme.moneyFormat);
             jQuery('#price_from').val(price_form);
             var price_to = ""+Shopify.formatMoney(end*100, theme.moneyFormat);
             jQuery('#price_to').val(price_to);

             jQuery('#page_no').val(1);
             jQuery('#pagination').val('');
          
             graphqlDataCall();     
             option = true;
             return false;
         }
       
       }
     });

    var start_num = parseInt(start);
	var end_num = parseInt(end);

	var start_dec = start_num.toFixed(0);
	var end_dec = end_num.toFixed(0);

	jQuery('#price_left_hidden').val(start_dec);
	jQuery('#price_right_hidden').val(end_dec);
	jQuery('#price_from').val(currency_symbol + " " + addCommas(start_dec));
	jQuery('#price_to').val(currency_symbol + " " + addCommas(end_dec));
}

function get_priceindex(value) {
	var pos = 0
	for (i = 0; i < price.length; i++) {
		if (price[i] == value) {
			pos = i;
			break;
		}
	}
	return pos;
}


/*** Price Validation Start ***/
$("#price_to").keypress(function(e) {
	//if the letter is not digit then display error and don't type anything
	if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
		return false;
	}
});

$("#price_from").keypress(function(e) {
	//if the letter is not digit then display error and don't type anything
	if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
		return false;
	}
});
/*** Price Validation End ***/

function replace_price_to() {

	if (jQuery('#price_to').val() == '') {
		var value = parseFloat(jQuery('#price_right_hidden').val());
        var formatted_price = ""+Shopify.formatMoney(value*100, theme.moneyFormat);
		//jQuery('#price_to').val(currency_symbol + " " + numberWithCommas(value.toFixed(0)));
       jQuery('#price_to').val(formatted_price); 
		return false;
	} else {
		var value = jQuery('#price_to').val();
        value = value.replace('£', '');
	}

	//var value1 = jQuery('#price_from').val();
   var value1 = jQuery('#price_left_hidden').val();
  
	value = value.replace(/[^\d\.]/g, '');
	value1 = value1.replace(/[^\d\.]/g, '');

    if(value.indexOf('.')!=-1){    
      value = value.replace(/\./g, '');
  	  value1 = value1.replace(/\./g, '');    
    }else if(value.indexOf(',')!=-1){
       value=value.replace(/[^\d\.]/g, '');
       value1=value1.replace(/[^\d\.]/g, '');
    }

	value = parseInt(value);
	value1 = parseInt(value1);

	if (isNaN(value) != false) {
		var value = maxDiamondPrice;
		alert("Please enter value in number");
		jQuery('#1000000').val(currency_symbol + value);
	} else if (value > maxDiamondPrice) {        
		alert('Incorrect price range!');
		var valLimit = parseFloat(jQuery('#price_right_hidden').val());
        var formatted_price = ""+Shopify.formatMoney(valLimit*100, theme.moneyFormat);
		//jQuery('#price_to').val(currency_symbol + "" + numberWithCommas(valLimit.toFixed(0)));
        jQuery('#price_to').val(formatted_price);   
		return false;
	} else if (value1 > value) {      
		alert('Incorrect price range!');
		var valLimit = parseFloat(jQuery('#price_right_hidden').val());
        var formatted_price = ""+Shopify.formatMoney(valLimit*100, theme.moneyFormat);
		//jQuery('#price_to').val(currency_symbol + "" + numberWithCommas(valLimit.toFixed(0)));
      jQuery('#price_to').val(formatted_price); 
		return false;
	} else if (value1 == '') {
		jQuery('#price_from').val(value1);
	}

	jQuery('#price_right_hidden').val(value.toFixed(0));
	jQuery('#price_left_hidden').val(value1.toFixed(0));
	price_slider_render(value1, value, false);

}

function replace_price_from() {
	if (jQuery('#price_from').val() == '') {
		var value = parseFloat(jQuery('#price_left_hidden').val());
        var formatted_price = ""+Shopify.formatMoney(value*100, theme.moneyFormat);
		//jQuery('#price_from').val(currency_symbol + "" + numberWithCommas(value.toFixed(0)));
       jQuery('#price_from').val(formatted_price);
		return false;
	} else {
		var value = jQuery('#price_from').val();
        value = value.replace('£', '');
	}
	//var value1 = jQuery('#price_to').val();
    var value1 = jQuery('#price_right_hidden').val();

    if(value.indexOf('.')!=-1){    
      value = value.replace(/\./g, '');
      value1 = value1.replace(/\./g, '');    
    }else if(value.indexOf(',')!=-1){
       value=value.replace(/[^\d\.]/g, '');
       value1=value1.replace(/[^\d\.]/g, '');
    }

	//value = value.replace(/[^\d\.]/g, '');
	//value1 = value1.replace(/[^\d\.]/g, '');
	value = parseInt(value);
	value1 = parseInt(value1);
    
	if (isNaN(value) != false) {
		var value = minDiamondPrice;
        var formatted_price = ""+Shopify.formatMoney(value*100, theme.moneyFormat);
		alert("Please enter value in number");
        jQuery('#price_from').val(formatted_price);
		//jQuery('#price_from').val(currency_symbol + value);
	} else if (value < minDiamondPrice) {
		alert('Incorrect price range!');
		var valLimit = parseFloat(jQuery('#price_left_hidden').val());
        var formatted_price = ""+Shopify.formatMoney(valLimit*100, theme.moneyFormat);
        jQuery('#price_from').val(formatted_price);
		//jQuery('#price_from').val(currency_symbol + "" + numberWithCommas(valLimit.toFixed(0)));
		return false;
	} else if (value > value1) {
		alert('Incorrect price range!');
		price_slider_render(price[0], value1, false);
		return false;
	}

	jQuery('#price_left_hidden').val(value.toFixed(0));
	jQuery('#price_right_hidden').val(value1.toFixed(0));
	price_slider_render(value, value1, false);

}
/*** Diamond Price Filter End ***/

/*** Diamond Depth Filter Start ***/
var depth = [];

for (i = 45; i < 90; i = i + 0.10) {
	var dec = i.toFixed(2);
	depth.push(dec);
}

var min_depth_filter = 45.00;
var max_depth_filter = 90.00;

function depth_slider_render(start, end, option) {
 
	var start2 = getClosestNum(start, depth);
	var end2 = getClosestNum(end, depth);
	var start1 = get_index(start2, depth);
	var start11 = get_index(start, depth);
	var end11 = get_index(end, depth);
	var end1 = get_index(end2, depth);

     //session depth filter selected
     var isSelected = false;      
     if(parseInt(start) != parseInt(min_depth_filter) || parseInt(end) != parseInt(max_depth_filter)){
       isSelected = true;
     }

     var depthTitle = 'Depth: '+start+' % - '+end+' %';
     setSelectedFilter(depthTitle,"depth_slider_render('"+min_depth_filter+"', '"+max_depth_filter+"','true')",isSelected,'depth');
     //end
  
	jQuery("#depth-slider").slider({
		range: true,
		min: 0,
		max: depth.length - 1,
		values: [start1, end1],
		slide: function(event, ui) {
			emptyResultDiv();
          
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}

			$("#depth_from").val(depth[parseInt(ui.values[0])] + '%');
			$('#depth_left_hidden').val(depth[parseInt(ui.values[0])]);
			$('#depth_to').val(depth[parseInt(ui.values[1])] + '%');
			$('#depth_right_hidden').val(depth[parseInt(ui.values[1])]);
		},
		change: function(event, ui) {
			emptyResultDiv();
          
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}	

			if (option) {
				jQuery('#page_no').val(1);
				jQuery('#pagination').val('');	

                $("#depth_from").val(depth[parseInt(ui.values[0])] + '%');
    			$('#depth_left_hidden').val(depth[parseInt(ui.values[0])]);
    			$('#depth_to').val(depth[parseInt(ui.values[1])] + '%');
    			$('#depth_right_hidden').val(depth[parseInt(ui.values[1])]);

                 //applied filter start
                 var isSelected = false;               
                 if(depth[parseInt(ui.values[0])] != parseInt(min_depth_filter) || depth[parseInt(ui.values[1])] != parseInt(max_depth_filter)){
                       isSelected = true;
                 }
                var depthTitle = 'Depth: '+depth[parseInt(ui.values[0])] + ' %'+' - '+depth[parseInt(ui.values[1])] + ' %';
                setSelectedFilter(depthTitle,"depth_slider_render('"+min_depth_filter+"', '"+max_depth_filter+"','true')",isSelected,'depth');
    			
            }
                //end
            
              var reportFlag = jQuery('#tps_search_by_report_no').val();    
              if(reportFlag == ''){
                graphqlDataCall();
              }
		}

	});

	var Start_limit = parseFloat(start);
	var End_limit = parseFloat(end);

	$("#depth_from").val(Start_limit.toFixed(2) + '%');
	$("#depth_to").val(End_limit.toFixed(2) + '%');
	$('#depth_left_hidden').val(start);
	$('#depth_right_hidden').val(end);
}

function replace_depth_from() {

	var min_depth_value = 45.00;

	if (jQuery('#depth_from').val() == '') {
		var value = parseFloat(jQuery('#depth_left_hidden').val());
		jQuery('#depth_from').val((value.toFixed(2)) + '%');
		return false;
	} else {
		var depth_value = parseFloat(jQuery('#depth_from').val());
		var hidden_depth_value = $('#depth_left_hidden').val();
	}
	
	var value = depth_value;
	
	var depth_value1_comma = value;
	value = depth_value1_comma;

	var value1 = parseFloat($('#depth_to').val());
	
	if (isNaN(value) != false) {
		var value = 45.00;
		alert("Please enter value in number");
		jQuery('#depth_from').val(value + '%');
	} else if (value > value1) {
		alert('Incorrect depth range!');
		var value = parseFloat(jQuery('#depth_left_hidden').val());
		jQuery('#depth_from').val((value.toFixed(2)) + '%');
		return false;
	} else if (depth_value < min_depth_value) {
		alert('Incorrect depth range!');
		$('#depth_from').val(min_depth_value + "%");
		depth_slider_render(min_depth_value, value1, true);
		return false;
	}

	$('#depth_left_hidden').val(value);
	$('#depth_right_hidden').val(value1);

	depth_slider_render(value, value1, true);
}

function replace_depth_to() {

	var max_depth_value = 90;

	if (jQuery('#depth_to').val() == '') {
		var value = parseFloat(jQuery('#depth_right_hidden').val());
		jQuery('#depth_to').val((value.toFixed(2)) + '%');
		return false;
	} else {
		var depth_value = parseFloat(jQuery('#depth_to').val());
		var hidden_depth_value = $('#depth_right_hidden').val();
	}	
	value = depth_value;
	var depth_value1_comma = value;
	value = depth_value1_comma;

	var value1 = parseFloat($('#depth_from').val());

	if (isNaN(value) != false) {
		var value = 90.00;
		alert('Please enter value in number');
		jQuery('#depth_to').val(value + '%');
	} else if (value1 > value) {
		alert('Incorrect depth range!');
		var value = parseFloat(jQuery('#depth_right_hidden').val());
		jQuery('#depth_to').val((value.toFixed(2)) + '%');
		return false;
	} else if (value > max_depth_value) {
		alert('Incorrect depth range!');
		$('#depth_to').val(max_depth_value + "%");
		depth_slider_render(value1, max_depth_value, true);
		return false;
	}

	$('#depth_right_hidden').val(value);
	$('#depth_left_hidden').val(value1);

	depth_slider_render(value1, value, true);
}
/*** Diamond Depth Filter End ***/

/*** Diamond Table Filter Start ***/
var table = [];

for (i = 45; i < 90; i = i + 0.10) {
	var dec = i.toFixed(2);
	table.push(dec);
}

var min_table_filter = 45.00;
var max_table_filter = 90.00;

function table_slider_render(start, end, option) {
	var start2 = getClosestNum(start, table);
	var end2 = getClosestNum(end, table);
	var start1 = get_index(start2, table);
	var start11 = get_index(start, table);
	var end11 = get_index(end, table);
	var end1 = get_index(end2, table);

    //session depth filter selected
     var isSelected = false;
     if(start != parseInt(min_table_filter) || end != parseInt(max_table_filter)){
       isSelected = true;
     }

     var tableTitle = 'Table: '+start+' % - '+end+' %';
     setSelectedFilter(tableTitle,"table_slider_render('"+parseInt(min_table_filter)+"', '"+parseInt(max_table_filter)+"','true')",isSelected,'table');
     //end
  
	jQuery("#table-slider").slider({
		range: true,
		min: 0,
		max: table.length - 1,
		values: [start1, end1],
		slide: function(event, ui) {
			emptyResultDiv();
          
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}

			$("#table_from").val(table[parseInt(ui.values[0])] + '%');
			$('#table_left_hidden').val(table[parseInt(ui.values[0])]);
			$('#table_to').val(table[parseInt(ui.values[1])] + '%');
			$('#table_right_hidden').val(table[parseInt(ui.values[1])]);
		},
		change: function(event, ui) {
			emptyResultDiv();
          
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}
			
			if (option) {
				if (option == true) {
					jQuery('#page_no').val(1);
					jQuery('#pagination').val('');					

                    $("#table_from").val(table[parseInt(ui.values[0])] + '%');
        			$('#table_left_hidden').val(table[parseInt(ui.values[0])]);
        			$('#table_to').val(table[parseInt(ui.values[1])] + '%');
        			$('#table_right_hidden').val(table[parseInt(ui.values[1])]);
                 
                    //applied filter start
                     var isSelected = false;
                     if(table[parseInt(ui.values[0])] != min_table_filter || table[parseInt(ui.values[1])] != max_table_filter){
                           isSelected = true;
                     }
                    var tableTitle = 'Table: '+table[parseInt(ui.values[0])] + ' %'+' - '+table[parseInt(ui.values[1])] + ' %';
                    setSelectedFilter(tableTitle,"table_slider_render('"+min_table_filter+"', '"+max_table_filter+"','true')",isSelected,'table');

                    var reportFlag = jQuery('#tps_search_by_report_no').val();                
                    if(reportFlag == ''){
                      graphqlDataCall();
                    }
				}


			}
		}

	});

	var Start_limit = parseFloat(start);
	var End_limit = parseFloat(end);

	$("#table_from").val(Start_limit.toFixed(2) + '%');
	$("#table_to").val(End_limit.toFixed(2) + '%');

	$('#table_left_hidden').val(start);
	$('#table_right_hidden').val(end);
}

function replace_table_from() {

	var min_table_value = 45;

	if (jQuery('#table_from').val() == '') {
		var value = parseFloat(jQuery('#table_left_hidden').val());
		jQuery('#table_from').val((value.toFixed(2)) + '%');
		return false;
	} else {
		var table_value = parseFloat(jQuery('#table_from').val());
		var hidden_table_value = $('#table_left_hidden').val();
	}
	
	var value = table_value;
	var table_value1_comma = value;
	value = table_value1_comma;

	var value1 = parseFloat($('#table_to').val());
	
	if (isNaN(value) != false) {
		var value = 45.00;
		alert('Please enter value in number');
		jQuery('#table_from').val(value + '%');
	} else if (value > value1) {
		alert('Incorrect table range!');
		var value = parseFloat(jQuery('#table_left_hidden').val());
		jQuery('#table_from').val((value.toFixed(2)) + '%');
		return false;
	} else if (table_value < min_table_value) {
		alert('Incorrect table range!');
		$('#table_from').val(min_table_value + "%");
		table_slider_render(min_table_value, value1, true);
		return false;
	}

	$('#table_left_hidden').val(value);
	$('#table_right_hidden').val(value1);

	table_slider_render(value, value1, true);
}

function replace_table_to() {

	var max_table_value = 90;

	if (jQuery('#table_to').val() == '') {
		var value = parseFloat(jQuery('#table_right_hidden').val());
		jQuery('#table_to').val((value.toFixed(2)) + '%');
		return false;
	} else {
		var table_value = parseFloat(jQuery('#table_to').val());
		var hidden_table_value = $('#table_right_hidden').val();
	}

	value = table_value;
	var table_value1_comma = value;
	value = table_value1_comma;

	var value1 = parseFloat($('#table_from').val());
	
	if (isNaN(value) != false) {
		var value = 90.00;
		alert('Please enter value in number');
		jQuery('#table_to').val(value + '%');
	} else if (value1 > value) {
		alert('Incorrect table range!');
		var value = parseFloat(jQuery('#table_right_hidden').val());
		jQuery('#table_to').val((value.toFixed(2)) + '%');
		return false;
	} else if (value > max_table_value) {
		$('#table_to').val(max_table_value + "%");
		table_slider_render(value1, max_table_value, true);
		return false;
	}

	$('#table_right_hidden').val(value);
	$('#table_left_hidden').val(value1);

	table_slider_render(value1, value, true);
}
/*** Diamond Depth Filter End ***/

/***Diamond sorting Filter Start ***/
function sorting_data(sorting, className) {
    emptyResultDiv();
  
	var sortorder = '';
	var clas = className;

	jQuery('.datagrid-sort').each(function() {
		if (jQuery(this).hasClass('fa-angle-up')) {
			jQuery(this).removeClass('fa-angle-up').addClass('fa-angle-down');
		}
	});

	if ((mySelection[1] == sorting) && (mySelection[2] == 'asc')) {
		sortorder = 'desc';
		jQuery(clas).find('i').removeClass('fa-angle-down').addClass('fa-angle-up');
	} else {
		sortorder = 'asc';
		jQuery(clas).find('i').addClass('fa-angle-down').removeClass('fa-angle-up');
	}

    //grid view
    var sort_value = ''+sorting+'_'+sortorder;  
    var sort_text = jQuery('.'+sort_value).attr('value'); 
     
    jQuery('.sortvaluename').text(sort_text);  
  
	jQuery('#sort_call').val(sorting);
	jQuery('#sort_dir').val(sortorder);


	mySelection[1] = jQuery('#sort_call').val();
	mySelection[2] = jQuery('#sort_dir').val();
 
	jQuery('#page_no').val(1);
	jQuery('#pagination').val('');
	graphqlDataCall();
}
/*** Diamond sorting Filter End ***/

/*** Get Query Parameter Array from URL ***/
function getQueryMap(query) {
    if(typeof query !== 'string') {
       return null;
    }
    
    var toType = function(a) {
      return ({}).toString.call(a).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
    }, map = {};
    
  // map the hit query into a proper object
  query.replace(/([^&|\?=]+)=?([^&]*)(?:&+|$)/g, function (match, key, value) {
      if (key in map) {
          // the key already exists, so we need to check if it is an array, if not, make it an array and add the new value
          if (toType(map[key]) !== 'array') {
              // it's not an array - make it an array
              map[key] = [map[key]];
          }
          // push the new value into the array
          map[key].push(value);
      } else {
          // put the value into the map
          map[key] = value;
      }
  });
  return map;
}
/*** End ***/

/*** Mobile Gallery Functinality Start ***/ 
$(document).on("click", ".tps_dots", function() {
  var data_thumb = jQuery(this).attr("data-thumb");  
  jQuery(".tps_dots").removeClass("active"); 
  jQuery(this).addClass("active");
  
  jQuery(".tps_mobile_gallery_image").hide(); 
  jQuery(".tps_image_"+data_thumb).show(); 
});
/*** End ***/
